import { connect } from 'react-redux';
import AuthGate from '../../components/basic/AuthGate';

const mapStateToProps = state => ({
  user: state.user,
});

export default connect(mapStateToProps)(AuthGate);
